export default "__VITE_ASSET__Bdf2tSTf__"